import getWordEnding from "../../../../services/helpers/get-word-ending";

let updateCommentsCounters = () => {
    let selector = "[data-comments]";
    let counters = Array.from(document.querySelectorAll(selector)); // счетчики комментариев у поста
    
    return (count) => {
        counters.forEach(counter => {
            counter.textContent = count;
            let ending = counter.closest('[data-ending]');
            if (ending) {
                ending.setAttribute('data-ending', getWordEnding(count, getWordEnding.KEYS))
            }
        });
    }
};

export { updateCommentsCounters };
